<div class="product-tags" [class.empty] = "tags?.length === 0">
  @if (tags?.length === 0) {
    <div>&nbsp;</div>
  }
  <span>
    @for (tag of tags; track tag; let i = $index) {
      {{ tag }}
      @if (i < (tags?.length - 1)) {
        -
      }
    }
  </span>
</div>
